// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50e7e3f2","453":"91c9e50d","455":"ceb34dcc","828":"4b74d199","857":"d403c72f","977":"8d947beb"}[chunkId] + ".chunk.js";
};